import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import * as globals from '../settings';
import {LotteriesService} from '../lotteries.service';



@Injectable()
export class CounterService {
  lotteryTable: any;
  downloadTime: number;


  constructor(public lotteryService: LotteriesService, private http: HttpClient) {
    this.lotteryService.getLotteries(globals.appDomain + '/lottery/getTimeToResolve/reponse.json')
        .subscribe(
            result => {
              this.lotteryTable = result;
              this.downloadTime = Math.round((new Date()).getTime() / 1000);
            }
        );
  }






}
